import './index.pcss';
import $ from 'jquery';

let widthValue = $('.header__inner').width();

$(document).ready(function () {
    $('.tabs-projects__button-inner').css('width', widthValue)
    $('main').on('click','.tabs-projects__button-inner-mobile',function (e) {
        $('.tabs-projects__button-inner-mobile').toggleClass('--active');
        $('.tabs-projects__dropdown').slideToggle(600);
        e.preventDefault();
    });

    // $('main').on('click','li button', function () {
    //    let txtActive = $(this).text();
    //     setTimeout(function () {
    //         $('button.title').text(txtActive);
    //     }, 500);
    //     $('button.title').text();
    // });

    $(document).on('click', '.tabs-projects__button', function (){
        document.body.scrollTop = 0; // For Safari
        document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        window.setInterval(function(){
            $('.tabs-projects__button-inner').css('width', widthValue);
        }, 200);
    });
});

$(window).resize(function() {
    widthValue = $('.header__inner').width();
    $('.tabs-projects__button-inner').css('width', widthValue);
});